export default {"src":"/_next/static/media/longboarden.6c788f86.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};